export const DocumentTitleChange = (title) => {
  document.title = title.trim() ? `${title.trim()}` : "Drtech";
};
